import { render, staticRenderFns } from "./StudentListPanel.vue?vue&type=template&id=152fbf5e&scoped=true&lang=pug&"
import script from "./StudentListPanel.vue?vue&type=script&lang=ts&"
export * from "./StudentListPanel.vue?vue&type=script&lang=ts&"
import style0 from "./StudentListPanel.vue?vue&type=style&index=0&id=152fbf5e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152fbf5e",
  null
  
)

export default component.exports